import React, { useState, useEffect } from 'react';

import { Row, Col } from 'react-bootstrap';
import SkyPulseTable from 'components/SkyPulseTable';
import UsageFilter from '../UsageFilter';
import { getUTCShortDate } from 'utils';
import { WeekOptions, defaultUsageFilters } from 'constants';

import styles from './styles.module.css';

const columnDefinitions = [
  {
    name: 'Rank',
    key: 'rank',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-TVEpisodeTableColumn-rank',
  },
  {
    name: 'Show Title',
    key: 'title',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-TVEpisodeTableColumn-title',
  },
  {
    name: 'Season Episode',
    key: 'season_episode',
    size: 'small',
    className: styles.colWidth,
    dataCyClassName: 'Usage-TVEpisodeTableColumn-title',
  },
  {
    name: 'Passengers',
    key: 'passengers',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-TVEpisodeTableColumn-passengers',
  },
  {
    name: 'Passenger pool %',
    key: 'passenger_pool_per',
    size: 'small',
    className: styles.colWidth,
    sortable: true,
    dataCyClassName: 'Usage-TVEpisodeTableColumn-passengerPoolPer',
  },
  {
    name: 'Total view minutes',
    key: 'total_views_minutes',
    size: 'small',
    className: styles.colWidth,
    sortable: true,
    dataCyClassName: 'Usage-TVEpisodeTableColumn-totalViewsMin',
  },
  {
    name: 'Avg view minutes',
    key: 'avg_view_minutes',
    size: 'small',
    className: styles.colWidth,
    sortable: true,
    dataCyClassName: 'Usage-TVEpisodeTableColumn-avgViewmin',
  },
];

const data = [
  {
    rank: '1',
    title: 'Bryson DeChambeau',
    season_episode: 'Season 4 Episode 9',
    passengers: {
      display: '9,860',
      sort: 9860,
    },
    passenger_pool_per: '1.97%',
    total_views_minutes: {
      display: '205,088',
      sort: 205088,
    },
    avg_view_minutes: 21,
  },
  {
    rank: '2',
    title: 'Black Clover',
    season_episode: 'Season 1 Episode 5',
    passengers: {
      display: '9,437',
      sort: 9437,
    },
    passenger_pool_per: '1.89%',
    total_views_minutes: {
      display: '171,756',
      sort: 171756,
    },
    avg_view_minutes: 18,
  },
  {
    rank: '3',
    title: 'Asset Type',
    season_episode: 'Season 2 Episode 10',
    passengers: {
      display: '8,069',
      sort: 8069,
    },
    passenger_pool_per: '1.61%',
    total_views_minutes: {
      display: '187,191',
      sort: 187191,
    },
    avg_view_minutes: 23,
  },
  {
    rank: '4',
    title: 'Hollywood Squares',
    season_episode: 'Season 4 Episode 7',
    passengers: {
      display: '7,466',
      sort: 7466,
    },
    passenger_pool_per: '1.50%',
    total_views_minutes: {
      display: '171,711',
      sort: 171711,
    },
    avg_view_minutes: 23,
  },
  {
    rank: '5',
    title: 'ONE PIECE',
    season_episode: 'Season 1 Episode 11',
    passengers: {
      display: '7,386',
      sort: 7386,
    },
    passenger_pool_per: '1.47%',
    total_views_minutes: {
      display: '177,257',
      sort: 177257,
    },
    avg_view_minutes: 24,
  },
];

const TVEpisodes = () => {
  const [filterData, setFilterData] = useState(data);
  const [filters, setFilters] = useState(defaultUsageFilters);

  useEffect(() => {
    const { searchText } = filters;
    const filteredData = data.filter((obj) => {
      return obj.title.toLowerCase().startsWith(searchText?.toLowerCase());
    });
    setFilterData(filteredData);
  }, [filters]);

  const week = WeekOptions[filters.week];
  const options = { month: 'short', day: 'numeric' };
  return (
    <Row className={styles.root} noGutters>
      <Col>
        <Row className={styles.title} noGutters>
          <Col data-cy-id="Usage-TVEpisodes-Header" className="title_1">
            TV Episodes
          </Col>
        </Row>
        <Row noGutters>
          <UsageFilter
            onFilterClick={(filters) => {
              setFilters(filters);
            }}
            onClear={(filters) => {
              setFilters(filters);
            }}
          />
        </Row>
        <Row className={styles.dataContainer} noGutters>
          <Col className="h-100">
            <Row className={styles.tableContainer} noGutters>
              <Col className="h-100">
                <SkyPulseTable
                  columns={columnDefinitions}
                  rows={filterData}
                  title={
                    <Row>
                      <Col>
                        {filters.option === 'week'
                          ? `Week of:
                          ${new Date(week?.startDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          -
                          ${new Date(week?.endDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          , ${new Date(week?.endDt).getFullYear()}`
                          : `Starting ${getUTCShortDate(
                              filters.startingDt,
                            )}, for ${filters.noOfDays} ${
                              filters.noOfDays === 1 ? 'day' : 'days'
                            }`}
                      </Col>
                      <Col md="auto">
                        Pool: <b>500,145</b> passengers used system
                      </Col>
                    </Row>
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default TVEpisodes;
